import { Component } from '@angular/core';

@Component({
    selector: 'wdx-ff-sub-form-content',
    templateUrl: './sub-form-content.component.html',
    standalone: false,
})
export class FormSubFormContentComponent {}
